import React from 'react';
import Header from './Header';
import Footer from './Footer';

const HowToPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Use the same header as the main site */}
      <Header />
      
      {/* Coming Soon Content */}
      <div className="bg-gray-50 min-h-screen flex items-center justify-center">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="max-w-2xl mx-auto text-center">
            {/* Coming Soon Message */}
            <div className="bg-white rounded-2xl shadow-lg p-12">
              <div className="mb-8">
                <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
                  How To Guide
                </h1>
                <h2 className="text-2xl font-semibold mb-6" style={{ color: '#9CB75A' }}>
                  Coming Soon
                </h2>
              </div>
              
              <p className="text-lg text-gray-900 mb-8 leading-relaxed">
                We're working on a comprehensive guide to help you get the most out of the Hole In 1 App. 
                Check back soon for step-by-step instructions on recording shots, winning prizes, and connecting with other golfers.
              </p>
              
              <div className="space-y-4">
                <p className="text-gray-900 font-medium">
                  In the meantime, you can:
                </p>
                <ul className="text-gray-900 space-y-2">
                  <li>• Download the app when it launches</li>
                  <li>• Follow us on social media for updates</li>
                  <li>• Sign up for early access notifications</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Use the same footer as the main site */}
      <Footer />
    </div>
  );
};

export default HowToPage;